/* src/app/app.component.scss */
.navbar-collapse {
  background: #fff;
  padding: 20px;
}
/*# sourceMappingURL=app.component.css.map */
